<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">课程订单</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="View"
              link
              @click="click_edit(row)"
              >查看</el-button
            >
          </template>
        </MyTable>
        <MyPagination :total="total" @get-list="getList" ref="pagination" />
      </div>
    </div>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyButton from "@/components/Global/MyButton.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { ref, reactive } from "vue";

// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "input",
      label: "订单编号：",
      prop: "orderSn",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "input",
      label: "课程名称：",
      prop: "courseName",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "input",
      label: "用户名称：",
      prop: "userName",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "input",
      label: "联系电话：",
      prop: "phone",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          getList(formData);
        },
      },
    },
  ],
});

// 分页
const pagination = ref();
const total = ref(0);

// 表格
const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "订单编号", prop: "orderSn" },
    { label: "创建时间", prop: "createTime" },
    { label: "课程名称", prop: "courseName" },
    { label: "课程价格（元）", prop: "price" },
    { label: "用户名称", prop: "userName" },
    { label: "电话", prop: "phone" },
    { label: "支付时间", prop: "paymentTime" },
    { label: "支付金额", prop: "paymentAmount" },
    { label: "订单状态", prop: "orderStatus" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [
    {
        orderSn: "1231231",
        createTime: "2024-05-01",
        courseName:"测试课程1",
        price: "188",
        userName: "小王",
        phone: "15543465969",
        paymentTime:"2024-05-02",
        paymentAmount:"50",
        orderStatus:"已完成"
    },
    {
        orderSn: "1231231",
        createTime: "2024-05-01",
        courseName:"测试课程1",
        price: "188",
        userName: "小王",
        phone: "15543465969",
        paymentTime:"2024-05-02",
        paymentAmount:"50",
        orderStatus:"已完成"
    },
    {
        orderSn: "1231231",
        createTime: "2024-05-01",
        courseName:"测试课程1",
        price: "188",
        userName: "小王",
        phone: "15543465969",
        paymentTime:"2024-05-02",
        paymentAmount:"50",
        orderStatus:"已完成"
    }
  ],
});













</script>

<style lang="scss" scoped>
.container {
  .container-content {
    .content-title {
      color: #4aefff;
      font-size: 18px;
      position: relative;
      margin-bottom: 28px;
    }
    .content-title::after {
      content: "";
      position: absolute;
      top: 4px;
      left: -8px;
      width: 3px;
      height: 14px;
      background: #4aefff;
    }
  }
}
</style>
